/* PDP clone kit – review list: "Read more reviews" shows the rest of the cards on phones and becomes "Read fewer". */
(function () {
  'use strict';
  if (window.__pdpRlist) return;
  window.__pdpRlist = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rlist-more]');
    if (!b) return;
    var root = b.closest('[data-rlist]');
    var open = !root.classList.contains('is-open');
    root.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.textContent = open ? b.dataset.less : b.dataset.more;
  });
})();
